<template>
  <div class="flex justify-end">
    <div class="flex justify-between">
      <b-button
        id="show-btn"
        variant="primary"
        block
        item-info-button
        @click="openInfoModal()"
        ><i class="fas fa-info"></i
      ></b-button>

      <b-button id="show-btn" block @click="openCartModal()"
        ><i class="fas fa-cart-plus"></i
      ></b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopItemButtons",
  props: {
    itemid: {
      type: String,
      required: true,
      default: function () {
        return "10107";
      },
    },
    customerid: {
      type: String,
      required: false,
      default: function () {
        return null;
      },
    },
  },
  methods: {
    openCartModal() {
      this.$store.commit("itemModal/setType", "add-to-cart");
      this.$store.commit("itemModal/setItemId", this.itemid);
      this.$store.commit("itemModal/showModal");
    },
    openInfoModal() {
      this.$store.commit("itemModal/setType", "info");
      this.$store.commit("itemModal/setItemId", this.itemid);
      this.$store.commit("itemModal/showModal");
    },
  },
};
</script>
<style lang="scss">
.modal-content {
  border: none;
  -webkit-box-shadow: 3px 3px 6px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 6px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 6px -5px rgba(0, 0, 0, 0.75);
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000000a6 !important;
}
</style>
